var map = {
	"./Bloomberg.svg": 3304,
	"./Coinstelegram.svg": 2456,
	"./aibc.svg": 2648,
	"./aws.svg": 3160,
	"./bilaxy.svg": 2492,
	"./bitforex.svg": 6656,
	"./blackshot.svg": 6700,
	"./blockhain.svg": 2184,
	"./compaund.svg": 7500,
	"./cryptor.svg": 8800,
	"./crystal.svg": 7696,
	"./fox.svg": 2712,
	"./gains.svg": 4404,
	"./gulf.svg": 6216,
	"./hyper.svg": 4104,
	"./kron.svg": 268,
	"./lilamax.svg": 9219,
	"./listing.svg": 4980,
	"./newsmax.svg": 7012,
	"./ninja.svg": 2104,
	"./polka.svg": 6088,
	"./smartcredit.svg": 5604,
	"./stolik.svg": 8387,
	"./tilda.svg": 6032,
	"./tink.svg": 4220,
	"./trustpilot.svg": 4896,
	"./twilio.svg": 6804,
	"./uniswap.svg": 1840,
	"./wbs.svg": 8980,
	"./wisor.svg": 460,
	"./woodland.svg": 6132,
	"./yahoo.svg": 4872,
	"./yieldster.svg": 516
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4556;